import { render, staticRenderFns } from "./ebp-modal.vue?vue&type=template&id=603a89a0"
import script from "./ebp-modal.vue?vue&type=script&lang=js"
export * from "./ebp-modal.vue?vue&type=script&lang=js"
import style0 from "./ebp-modal.vue?vue&type=style&index=0&id=603a89a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports